function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardVoicemail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "forward_voicemail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "voicemail"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.46,17.79a6,6,0,0,0-5.91,5.92,6,6,0,0,0,1.39,3.76H14a6,6,0,0,0,1.4-3.76,6,6,0,0,0-5.92-5.92,5.92,5.92,0,0,0,0,11.83h14a5.92,5.92,0,1,0,0-11.83Zm-14,9.68a3.77,3.77,0,1,1,3.77-3.76A3.81,3.81,0,0,1,9.48,27.47Zm14,0a3.77,3.77,0,1,1,3.76-3.76A3.81,3.81,0,0,1,23.46,27.47Z",
    style: {
      fill: "#7c7c7c"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "23.38 11.79 15.38 4.79 15.38 8.79 7.38 8.79 7.38 14.79 15.38 14.79 15.38 18.79 23.38 11.79",
    style: {
      fill: "#00a6e7"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardVoicemail);
export default __webpack_public_path__ + "static/media/forward_voicemail.bd5b1542.svg";
export { ForwardRef as ReactComponent };